import { React, useState } from 'react';
import styled from 'styled-components';

const FullRangeInput = (props) => {
  const { defaultVal, changeFn } = props;

  const [value, setValue] = useState(defaultVal);

  function handleChange(e) {
    setValue(e.target.value);
    changeFn(e.target.value);
  }

  return (
    <TopLevelWrapper>
      <Text>폰트 크기</Text>
      <Input 
        type='range'
        min={14}
        max={44}
        value={value || ''}
        onChange={handleChange}/>
    </TopLevelWrapper>
  )
}

export default FullRangeInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  // gap: 8px;
  gap: 0.4166666666666667vw;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  // font-size: 12px;
  font-size: 0.625vw;

  margin: 0 0 0 0;

  color: #777777;
`;

const Input = styled.input`
  // width: 88px;
  width: 4.583333333333333vw;
  // height: 8px;
  height: 0.4166666666666667vw;

  border-radius: 8px;
  background-color: #ECECEC;

  -webkit-appearance: none;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;

    // width: 12px;
    width: 0.625vw;
    // height: 12px;
    height: 0.625vw;
    border-radius: 12px;

    background-color: #FF8B48;

    &:hover {
      cursor: pointer;
    }
  }
`;